import { render } from "./ConfirmationView.vue?vue&type=template&id=3d4b1252&scoped=true"
import script from "./ConfirmationView.vue?vue&type=script&lang=js"
export * from "./ConfirmationView.vue?vue&type=script&lang=js"

import "./ConfirmationView.vue?vue&type=style&index=0&id=3d4b1252&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4b1252"]])

export default __exports__